import { render, staticRenderFns } from "./preventionbrigadeEvidencePagination.vue?vue&type=template&id=3abbd474&"
import script from "./preventionbrigadeEvidencePagination.vue?vue&type=script&lang=js&"
export * from "./preventionbrigadeEvidencePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports